export enum FormFieldTypeDTO {
  Unknown = 0,
  Text = 1,
  TextArea = 3,
  Date = 4,
  Integer = 5,
  Decimal = 6,
  Boolean = 7,
}
